import './Works.css';
import Project from './Project';
import { useState } from 'react';
import MovieMovieIMG from '../../images/MovieMovieIMG.png';
import PorscheCloneIMG from '../../images/PorscheCloneIMG.png';
import JadooTravelIMG from '../../images/JadooTravelIMG.PNG';
import BeautiBopIMG from '../../images/BeautiBopIMG.png';
import CypherCityIMG from '../../images/CypherCityIMG.png';
import BeautiBopVID from '../../images/BeautiBopVID.mp4';
import CypherCityVID from '../../images/CypherCityVID.mp4';
import Airgue from '../../images/A.png'


function WorksContent() {

  const [currentVideo,setcurrentVideo] = useState();
  const [videoOpen,setvideoOpen] = useState();

  return (
    <div className = 'works-content-content'>
      
      {!videoOpen ? 
      <>
        <span className = 'works-content-content-subtitle'>Works</span>
        <span className = 'works-content-content-title'>RECENT PROJECTS</span>
        <div className = 'works-content-content-projects'>
          <Project
            hooks = {{currentVideo,setcurrentVideo,videoOpen,setvideoOpen}}
            genre = {"Front-end Development"}
            title = {"Beauti Bop"}
            video = {BeautiBopVID}
            desc = {"I crafted the web version of Beauti Bop, an empowering app tailored for young women and girls, during my internship with ENGAGEathon."}
            image = {BeautiBopIMG}
          />
          <Project
            genre = {"Full-Stack Development"}
            title = {"Airgue"}
            link = {"https://airgue.vercel.app/"}
            desc = {"Watch ChatGPT and Gemini debate any topic in real time and decide which AI makes the stronger argument."}
            image = {Airgue}
          />
          <Project
            genre = {"Front-end Development"}
            title = {"MovieMovie"}
            link = {"https://moviemovieus.vercel.app"}
            desc = {"MovieMovie is a multi-page streaming sight that dynamically displays details of movies and TV Shows using the use of TMBD API."}
            image = {MovieMovieIMG}
          />
          <Project
            genre = {"Full Stack Development"}
            title = {"Jadoo Travel"}
            link = {"https://jadootravel.vercel.app/"}
            desc = {"Jadoo is a travel and booking website I created with Firebase and React. Hit 'Log In' for Demo Account."}
            image = {JadooTravelIMG}
          />
          <Project
            genre = {"Front-end Development"}
            title = {"Porsche Clone"}
            link = {"https://porscheclone.vercel.app/"}
            desc = {"I developed a Porsche Website clone in React.js best practices, and integrated the Google Location API."}
            image = {PorscheCloneIMG}
          />
          <Project
            hooks = {{currentVideo,setcurrentVideo,videoOpen,setvideoOpen}}
            genre = {"Mobile App Development"}
            title = {"Cypher City"}
            video = {CypherCityVID}
            desc = {"I began the mobile app version of Cypher City, a app designed to help new artist begin their career, during my internship with ENGAGEathon."}
            image = {CypherCityIMG}
          />
        </div>
      </> 
      
      :
      
      <>
        <button onClick={()=>{setvideoOpen(false)}} className = 'works-content-content-exit'>X</button>
        <video autoPlay controls className = 'works-content-content-video'>
            <source src = {currentVideo} type="video/mp4" />
            Your browser does not support the video tag...
        </video>
      </>
      
      }
    </div>
  );
}

export default WorksContent;